/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumItem2 } from './EnumItem2';
import {
    EnumItem2FromJSON,
    EnumItem2FromJSONTyped,
    EnumItem2ToJSON,
    EnumItem2ToJSONTyped,
} from './EnumItem2';
import type { BonusAccountItem } from './BonusAccountItem';
import {
    BonusAccountItemFromJSON,
    BonusAccountItemFromJSONTyped,
    BonusAccountItemToJSON,
    BonusAccountItemToJSONTyped,
} from './BonusAccountItem';

/**
 * 
 * @export
 * @interface BonusAccountPageVo
 */
export interface BonusAccountPageVo {
    /**
     * 当前页
     * @type {number}
     * @memberof BonusAccountPageVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof BonusAccountPageVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof BonusAccountPageVo
     */
    totalRecord?: number;
    /**
     * 账户列表
     * @type {Array<BonusAccountItem>}
     * @memberof BonusAccountPageVo
     */
    records?: Array<BonusAccountItem>;
    /**
     * 账单类型枚举列表（可用账单设置用）
     * @type {Array<EnumItem2>}
     * @memberof BonusAccountPageVo
     */
    billTypeList?: Array<EnumItem2>;
}

/**
 * Check if a given object implements the BonusAccountPageVo interface.
 */
export function instanceOfBonusAccountPageVo(value: object): value is BonusAccountPageVo {
    return true;
}

export function BonusAccountPageVoFromJSON(json: any): BonusAccountPageVo {
    return BonusAccountPageVoFromJSONTyped(json, false);
}

export function BonusAccountPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAccountPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BonusAccountItemFromJSON)),
        'billTypeList': json['billTypeList'] == null ? undefined : ((json['billTypeList'] as Array<any>).map(EnumItem2FromJSON)),
    };
}

export function BonusAccountPageVoToJSON(json: any): BonusAccountPageVo {
    return BonusAccountPageVoToJSONTyped(json, false);
}

export function BonusAccountPageVoToJSONTyped(value?: BonusAccountPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BonusAccountItemToJSON)),
        'billTypeList': value['billTypeList'] == null ? undefined : ((value['billTypeList'] as Array<any>).map(EnumItem2ToJSON)),
    };
}

